import { Spin } from 'antd';
import styled from 'styled-components';

export const StyledSpinner = styled(Spin)`
  .ant-spin-dot {
    font-size: 60px !important;
  }

  svg {
    fill: #9f37ed !important;
  }
`;
